export const TEAMS_LINK_START_PATH = "/microsoft_teams/link";

export const TEAMS_DESCRIPTION =
  "Connect your Microsoft Teams account to attribute your activity across tools.";

export const TEAMS_LINK_GENERIC_ERROR = "Something went wrong. Please try again.";

// Any code not mapped here falls back to TEAMS_LINK_GENERIC_ERROR, so a new/unknown code
// degrades gracefully instead of going blank.
export const TEAMS_LINK_ERROR_MESSAGES: Record<string, string> = {
  already_claimed: "This Microsoft Teams account is already linked to another Spacelift user.",
  already_linked: "This Microsoft Teams account is already linked.",
};
